import { ExistingProvider, forwardRef, Type } from '@angular/core';

import { BaseInputDirective } from './base-input.directive';

/**
 * Creates provider that registers a component as PCS form control.
 *
 * @param type type of the component
 * @return provider for the given type
 * */
export function formControlFactory(type: Type<BaseInputDirective>): ExistingProvider {
  return {
    provide: BaseInputDirective,
    useExisting: forwardRef(() => type),
    multi: true
  };
}
